/**
 * @packageDocumentation
 * @module HackerAPI.Event.Team
 */
import { __extends } from "tslib";
import Member from "./member/member";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import Base from "../../base/base";
import { parseDate } from "../../utils/utils";
var Team = /** @class */ (function (_super) {
    __extends(Team, _super);
    /**
     * Creates a new team instance
     * @constructor
     * @param team
     */
    function Team(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, event_slug = _b.event_slug, eventSlug = _b.eventSlug, members = _b.members, updated_at = _b.updated_at, updatedAt = _b.updatedAt, created_at = _b.created_at, createdAt = _b.createdAt;
        var _this = _super.call(this) || this;
        /**
         * The team ID
         * @type { string }
         */
        _this.id = id;
        /**
         * The slug of the event that the team was created for
         * @type { string }
         */
        _this.eventSlug = event_slug || eventSlug;
        /**
         * The members of the team
         * @type { HackerAPI.Event.Team.Member[] }
         */
        _this.members = (members || []).map(function (m) { return new Member(m); });
        /**
         * When the team was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        /**
         * When the team was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        return _this;
    }
    Object.defineProperty(Team, "Member", {
        /**
         * The member class
         * @static
         * @const
         * @return { HackerAPI.Event.Team.Member }
         */
        get: function () {
            return Member;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetches a team using its id
     * @param team
     * @param team.id
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Team.fetch = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/teams/" + id,
            method: "GET",
            token: token
        }).then(function (data) { return new Team(data); });
    };
    /**
     * Fetches all teams that a user is a member of
     * @param user
     * @param user.id
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Team.fetchAllByUserId = function (_a, token) {
        var id = (_a === void 0 ? { id: "me" } : _a).id;
        return HackerAPIFetch({
            path: "/v2/users/" + id + "/teams",
            method: "GET",
            token: token
        }).then(function (data) { return data.map(function (datum) { return new Team(datum); }); });
    };
    /**
     * Creates a new team for a given event. It adds the person whose token was used to the team as well.
     * @param event - The event to create a team for
     * @param event.slug - The event slug
     * @param user - The user who's creating the team
     * @param user.token - The token to authenticate with
     * @returns
     */
    Team.create = function (_a, token) {
        var slug = _a.slug;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/teams",
            method: "POST",
            token: token
        }).then(function (data) { return new Team(data); });
    };
    /**
     * Adds a user to a team
     * @param team
     * @param [asUser] - Optionally authenticate as another user (admin only)
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Team.join = function (_a, asUser, token) {
        var teamId = _a.id;
        return HackerAPIFetch({
            path: "/v2/teams/" + teamId,
            method: "PUT",
            params: asUser ? { as_user: asUser.id } : {},
            token: token
        }).then(function (data) { return new Team(data); });
    };
    /**
     * Removes a user from a team
     * @param team
     * @param [asUser] - Removes the user who's token is attached to the request unless otherwise
     *                       specified (admin only)
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Team.leave = function (_a, asUser, token) {
        var teamId = _a.id;
        return HackerAPIFetch({
            path: "/v2/teams/" + teamId,
            method: "DELETE",
            token: token,
            params: asUser ? { as_user: asUser.id } : {}
        }).then(function (data) { return new Team(data); });
    };
    return Team;
}(Base));
export default Team;
//# sourceMappingURL=team.js.map